import React, {Component} from 'react';
import {Container, Col, Row, Button} from 'react-bootstrap';
import styled from 'styled-components';
import {withTranslation} from 'react-i18next';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import {Mutation} from 'react-apollo';
import Header from '../common/Header';
import Footer from '../common/Footer';
import CustomButton from '../common/CustomButton';
import MandatoryInput from '../../common/components/MandatoryInput';
import dashboardScreen from '../assets/img/browser-dashboard.png';
import {Card, CardGroup, CardText, CardTitle} from '../../common/look/ui-bootstrap/components';
import {validateEmail} from '../../utils';

const AttributeDiv = styled.div`
  ${({uppercase}) => uppercase && `
    text-transform: uppercase;
  `}
  font-family: 'Segoe UI Bold', sans-serif;
  font-size: 12px;
`;

const ConfirmBtn = styled(Button).attrs({
  className: 'btn-primary',
})`
  &&& {
    font-family: Montserrat-Semi-Bold, 'sans-serif';
    width: 60%;
    font-size: 16px;
    border-radius: 30px;
    background-color: #323232;
    border-color: transparent;
    height: 60px;
    box-shadow: 0px 6px 20.9px -9px black;
  }
`;

const GRAPHQL_MUTATION_SEND_CONTACT_FORM = gql`
  mutation sendMerchantContactForm($merchantContactFormInput: SendMerchantContactFormInput!){
      sendMerchantContactForm(merchantContactFormInput: $merchantContactFormInput)
  }
`;

class PartnerForm extends Component {
  state = {
    firstName: '',
    lastName: '',
    email: '',
    message: '',
    phone: '',
    brandName: '',
    emailSent: false,
    submitted: false,
    res: null,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  submitMail = GRAPHQL_MUTATION_SEND_CONTACT_FORM => {
    const {firstName, lastName, email, phone, message, brandName} = this.state;
    if (firstName !== '' && lastName !== '' && message !== '' && brandName !== '' && validateEmail(email)) {
      GRAPHQL_MUTATION_SEND_CONTACT_FORM({
        variables: {
          merchantContactFormInput: {
            firstName,
            lastName,
            message,
            email,
            phone,
            brandName,
          },
        },
      })
        .then(() => {
          this.setState({emailSent: true});
          window.scrollTo(0, 0);
        });
    }
    this.setState({submitted: true});
  };

  render() {
    const {t, history} = this.props;
    const {firstName, lastName, email, brandName, submitted, emailSent} = this.state;
    const inputStyle = {fontSize: 18};
    return (
      <Mutation mutation={GRAPHQL_MUTATION_SEND_CONTACT_FORM}>
        {GRAPHQL_MUTATION_SEND_CONTACT_FORM => {
          return (
            <>
              <Header currentAnchor={'newPartner'} links />
              <Container className="container-full partner-form-container">
                {emailSent ? (
                  <div className="justified-content">
                    <Card className="card-small">
                      <CardGroup className="centered-card-group">
                        <CardTitle>{t('confirmationMsgTitle')}</CardTitle>
                        <CardText>{t('confirmationMsgBody')}</CardText>
                      </CardGroup>
                      <ConfirmBtn onClick={() => history.push('/')}>{t('OK')}</ConfirmBtn>
                    </Card>
                  </div>
                ) : (
                  <Row className="partner-form-row">
                    <Container className="limited-container">
                      <Row className="form-big">
                        <Col xs={{span: 6, offset: 1}}>
                          <div className="form-title">{`${t('becomePartner')} : `}</div>
                          <Row>
                            <MandatoryInput className="partner-input" type="text" customStyle={inputStyle} onChange={(name, text) => this.setState({lastName: text})} title={t('yourName')} name={'last_name'} uppercase={false} sizeSm={6} show={submitted && lastName === ''} />
                            <MandatoryInput className="partner-input form-firstname" type="text" customStyle={inputStyle} onChange={(name, text) => this.setState({firstName: text})} title={t('yourFirstname')} name={'first_name'} uppercase={false} sizeSm={6} show={submitted && firstName === ''} />
                            <MandatoryInput className="partner-input" type="text" customStyle={inputStyle} onChange={(name, text) => this.setState({email: text})} title={t('yourEmail')} name={'email'} uppercase={false} sizeSm={6} show={submitted && !validateEmail(email)} customText={t('wrongMail')} />
                            <MandatoryInput className="partner-input form-firstname" type="text" customStyle={inputStyle} onChange={(name, text) => this.setState({phone: text})} title={t('yourPhone')} name={'tel'} uppercase={false} sizeSm={6} />
                            <MandatoryInput className="partner-input" type="text" customStyle={inputStyle} onChange={(name, text) => this.setState({brandName: text})} title={t('yourBrand')} name={'brandName'} uppercase={false} sizeSm={6} show={submitted && brandName === ''} />
                            <Col xs={12}>
                              <label className="mandatory-label">
                                <AttributeDiv className="label-name">{t('yourMessage')}</AttributeDiv>
                                <textarea required onChange={e => this.setState({message: e.target.value})} name={'message'} className={'text-area'} rows={8} />
                              </label>
                            </Col>
                            <div className="send-btn">
                              <CustomButton text={t('send')} onClick={() => this.submitMail(GRAPHQL_MUTATION_SEND_CONTACT_FORM)}/>
                            </div>
                            <div className="send-btn">
                              <span className="required">* {t('mandatory')}</span>
                            </div>
                          </Row>
                        </Col>
                        <Col xs={5} className="right-screen">
                          <img src={dashboardScreen} alt="demo-screen" className="demo-screen" />
                        </Col>
                      </Row>
                      <Row className="form-small">
                        <Col xs={12}>
                          <div className="form-title">{`${t('becomePartner')} : `}</div>
                          <Row>
                            <MandatoryInput
                              className="form-input"
                              type="text"
                              customStyle={inputStyle}
                              onChange={(name, text) => this.setState({lastName: text})}
                              title={t('yourName')}
                              name={'last_name'}
                              uppercase={false}
                              sizeSm={6}
                              show={submitted && lastName === ''}
                            />
                            <MandatoryInput
                              className="form-input form-firstname"
                              type="text"
                              customStyle={inputStyle}
                              onChange={(name, text) => this.setState({firstName: text})}
                              title={t('yourFirstname')}
                              name={'first_name'}
                              uppercase={false}
                              sizeSm={6}
                              show={submitted && firstName === ''}
                            />
                            <MandatoryInput
                              className="form-input"
                              type="text"
                              customStyle={inputStyle}
                              onChange={(name, text) => this.setState({email: text})}
                              title={t('yourEmail')}
                              name={'email'}
                              uppercase={false}
                              sizeSm={6}
                              show={submitted && !validateEmail(email)} customText={t('wrongMail')}
                            />
                            <MandatoryInput
                              className="form-input form-firstname"
                              type="text"
                              customStyle={inputStyle}
                              onChange={(name, text) => this.setState({phone: text})}
                              title={t('yourPhone')}
                              name={'tel'}
                              uppercase={false}
                              sizeSm={6}
                            />
                            <MandatoryInput
                              className="form-input"
                              type="text"
                              customStyle={inputStyle}
                              onChange={(name, text) => this.setState({brandName: text})}
                              title={t('yourBrand')}
                              name={'brandName'}
                              uppercase={false}
                              sizeSm={6}
                              show={submitted && brandName === ''}
                            />
                            <Col xs={12}>
                              <label className="mandatory-label">
                                <AttributeDiv className="label-name">{t('yourMessage')}</AttributeDiv>
                                <textarea
                                  required
                                  onChange={e => this.setState({message: e.target.value})}
                                  name={'message'}
                                  className={'form-input text-area'}
                                  rows={7}
                                />
                              </label>
                            </Col>
                            <div className="send-btn">
                              <CustomButton text={t('send')} onClick={() => this.submitMail(GRAPHQL_MUTATION_SEND_CONTACT_FORM)}/>
                            </div>
                            <div className="send-btn">
                              <span className="required">* {t('mandatory')}</span>
                            </div>
                          </Row>
                        </Col>
                        <Col xs={12} className="right-screen">
                          <img src={dashboardScreen} alt="demo-screen" className="demo-screen" />
                        </Col>
                      </Row>
                    </Container>
                  </Row>
                )}
              </Container>
              <Footer />
            </>
          );
        }}
      </Mutation>

    );
  }
}

PartnerForm.propTypes = {
  t: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default withTranslation('homepage')(PartnerForm);
